import { cn as e } from "../shared/utils.js";
import { Button as t } from "../button/primitive/button.js";
import { BottomDrawer as n } from "../bottom-drawer/index.js";
import { breakpointQueries as r } from "../shared/breakpoints.js";
import { useMediaQuery as i } from "../shared/hooks/use-media-query.js";
import { menuItemVariants as a, menuSeparatorVariants as o } from "./menu.styles.js";
import { MenuPrimitives as s } from "./menu.js";
import { XCloseIcon as c } from "@systemeio/icons";
import { createElement as l, isValidElement as u, useCallback as d, useEffect as f, useRef as p, useState as m } from "react";
import { jsx as h, jsxs as g } from "react/jsx-runtime";
import { mergeProps as _ } from "@base-ui/react/merge-props";
import { useRender as v } from "@base-ui/react/use-render";
//#region src/menu/adaptive-menu.tsx
function y(e) {
	e.disabled || e.onSelect?.();
}
function b(e) {
	return e.closeOnSelect !== !1;
}
function x(e, t) {
	let n = e.render ? void 0 : e.anchorProps?.href;
	return _(e.anchorProps, {
		...t,
		href: n
	});
}
function S(e) {
	return {
		id: e.id,
		type: "action",
		label: e.label,
		disabled: !0,
		className: e.className,
		size: e.size,
		state: e.state,
		closeOnSelect: !1,
		dataAttributes: e.dataAttributes
	};
}
function C() {
	return /* @__PURE__ */ h("div", {
		role: "separator",
		"data-slot": "menu-separator",
		"data-testid": "menu-separator",
		className: o()
	});
}
function w(t, n) {
	return e(a({
		size: t.size ?? n,
		state: t.state ?? "default",
		surface: "drawer"
	}), t.className);
}
function T({ item: e, size: t, onRequestClose: n }) {
	let r = (t) => {
		if (e.disabled) {
			t.preventDefault();
			return;
		}
		y(e), b(e) && n();
	};
	return v({
		defaultTagName: e.disabled ? "div" : "button",
		props: {
			...e.dataAttributes,
			type: "button",
			disabled: e.disabled,
			"data-slot": "menu-item",
			"data-testid": "menu-item",
			"data-disabled": e.disabled ? "" : void 0,
			className: w(e, t),
			children: e.label,
			onClick: r
		},
		render: e.render
	});
}
function E({ item: e, size: t, onRequestClose: n }) {
	let r = () => {
		y(e), b(e) && n();
	};
	return v({
		defaultTagName: "a",
		props: x(e, {
			...e.dataAttributes,
			"data-slot": "menu-item",
			"data-testid": "menu-item",
			className: w(e, t),
			children: e.label,
			onClick: r
		}),
		render: e.render
	});
}
function D({ open: a, defaultOpen: o = !1, onOpenChange: _, size: v = "md", disabled: w = !1, trigger: D, items: O, drawerTitle: k, className: A, triggerProps: j, align: M = "end", openOnHover: N = !1 }) {
	let P = i(r.isMobile, { initializeWithValue: !1 }), F = a !== void 0, [I, L] = m(o), R = F ? a : I, z = d((e) => {
		F || L(e), _?.(e);
	}, [F, _]), B = p(void 0);
	f(() => {
		let e = window.matchMedia(r.isMobile).matches;
		B.current === void 0 && (B.current = e), P === e && B.current !== P && (B.current = P, R && z(!1));
	}, [
		P,
		R,
		z
	]);
	let V = {
		open: R,
		disabled: w
	}, H = u(D) ? D : void 0, U = typeof D == "function" ? D(V) : H ? void 0 : D;
	return P ? /* @__PURE__ */ g(n.Root, {
		open: R,
		onOpenChange: (e) => {
			z(e);
		},
		children: [/* @__PURE__ */ h(n.Trigger, {
			...j,
			className: e("focus-visible:focus-ring-primary outline-none", j?.className),
			disabled: w,
			render: H,
			children: U
		}), /* @__PURE__ */ g(n.Popup, { children: [k ? /* @__PURE__ */ g(n.Header, {
			className: "flex-row items-start gap-2.5",
			children: [/* @__PURE__ */ h(n.Title, {
				className: "min-w-0 flex-1",
				children: k ?? j?.["aria-label"] ?? "Menu"
			}), /* @__PURE__ */ h(n.Close, {
				"aria-label": "Close",
				className: "shrink-0",
				render: /* @__PURE__ */ h(t, {
					variant: "ghost-gray",
					size: "icon-sm"
				}),
				children: /* @__PURE__ */ h(c, {})
			})]
		}) : /* @__PURE__ */ h(n.Title, {
			className: "sr-only",
			children: j?.["aria-label"] ?? "Menu"
		}), /* @__PURE__ */ h(n.Content, {
			className: "gap-0 px-0 py-4",
			children: /* @__PURE__ */ h("div", {
				"data-slot": "menu-list",
				"data-testid": "menu-list",
				className: e("flex w-full flex-col", A),
				children: O.map((e) => e.type === "separator" ? /* @__PURE__ */ h(C, {}, e.id) : e.type === "link" && e.disabled ? /* @__PURE__ */ h(T, {
					item: S(e),
					size: v,
					onRequestClose: () => {
						z(!1);
					}
				}, e.id) : e.type === "link" ? /* @__PURE__ */ h(E, {
					item: e,
					size: v,
					onRequestClose: () => {
						z(!1);
					}
				}, e.id) : /* @__PURE__ */ h(T, {
					item: e,
					size: v,
					onRequestClose: () => {
						z(!1);
					}
				}, e.id))
			})
		})] })]
	}) : /* @__PURE__ */ g(s.Root, {
		open: R,
		onOpenChange: (e) => {
			z(e);
		},
		disabled: w,
		children: [/* @__PURE__ */ h(s.Trigger, {
			...j,
			className: j?.className,
			disabled: w,
			openOnHover: N,
			render: H,
			children: typeof D == "function" ? (e) => D({
				open: e.open,
				disabled: e.disabled
			}) : U
		}), /* @__PURE__ */ h(s.Portal, { children: /* @__PURE__ */ h(s.Positioner, {
			align: M,
			className: "z-60",
			children: /* @__PURE__ */ h(s.Popup, {
				className: A,
				children: O.map((e) => {
					if (e.type === "separator") return /* @__PURE__ */ h(s.Separator, {}, e.id);
					let t = e.size ?? v, n = b(e);
					if (e.type === "link" && e.disabled) {
						let n = S(e);
						return /* @__PURE__ */ l(s.Item, {
							...e.dataAttributes,
							key: e.id,
							size: t,
							state: e.state,
							disabled: !0,
							"data-slot": "menu-item",
							"data-testid": "menu-item",
							className: e.className,
							closeOnClick: !1
						}, n.label);
					}
					if (e.type === "link") {
						let r = x(e, { onClick: () => {
							y(e);
						} });
						return /* @__PURE__ */ l(s.LinkItem, {
							...e.dataAttributes,
							key: e.id,
							size: t,
							state: e.state,
							className: e.className,
							"data-slot": "menu-item",
							"data-testid": "menu-item",
							render: e.render,
							closeOnClick: n,
							...r
						}, e.label);
					}
					return /* @__PURE__ */ l(s.Item, {
						...e.dataAttributes,
						key: e.id,
						size: t,
						state: e.state,
						disabled: e.disabled,
						"data-slot": "menu-item",
						"data-testid": "menu-item",
						className: e.className,
						closeOnClick: !e.disabled && n,
						render: e.render,
						onClick: () => {
							y(e);
						}
					}, e.label);
				})
			})
		}) })]
	});
}
//#endregion
export { D as AdaptiveMenu };
